module.exports = __webpack_public_path__ + "img/banner-3.bf5bb3db.jpg";